import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Switch20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M15.0304 6.96966L10.0001 1.93933L4.96973 6.96966L6.03039 8.03032L10.0001 4.06065L13.9697 8.03032L15.0304 6.96966Z'
      fill='currentColor'
    />
    <path
      d='M4.96974 13.0303L10.0001 18.0607L15.0304 13.0303L13.9697 11.9697L10.0001 15.9393L6.0304 11.9697L4.96974 13.0303Z'
      fill='currentColor'
    />
  </Svg>
);

Switch20.displayName = 'Switch20';
export default Switch20;
